/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { CellInBoundMetricsExecutionTime } from './cell-in-bound-metrics-execution-time';
// May contain unused imports in some cases
// @ts-ignore
import { InBoundMetrics } from './in-bound-metrics';
// May contain unused imports in some cases
// @ts-ignore
import { InBoundWarnings } from './in-bound-warnings';
// May contain unused imports in some cases
// @ts-ignore
import { InputFile } from './input-file';
// May contain unused imports in some cases
// @ts-ignore
import { OutputFile } from './output-file';
// May contain unused imports in some cases
// @ts-ignore
import { User } from './user';

/**
 *
 * @export
 * @interface ServiceExecution
 */
export interface ServiceExecution {
    /**
     *
     * @type {string}
     * @memberof ServiceExecution
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceExecution
     */
    status?: ServiceExecutionStatusEnum;
    /**
     *
     * @type {number}
     * @memberof ServiceExecution
     */
    run?: number;
    /**
     *
     * @type {User}
     * @memberof ServiceExecution
     */
    author?: User;
    /**
     *
     * @type {{ [key: string]: InputFile | undefined; }}
     * @memberof ServiceExecution
     */
    inputs?: { [key: string]: InputFile | undefined };
    /**
     *
     * @type {{ [key: string]: OutputFile | undefined; }}
     * @memberof ServiceExecution
     */
    outputs?: { [key: string]: OutputFile | undefined };
    /**
     *
     * @type {Array<InBoundWarnings>}
     * @memberof ServiceExecution
     */
    warnings?: Array<InBoundWarnings>;
    /**
     *
     * @type {InBoundMetrics}
     * @memberof ServiceExecution
     */
    metrics?: InBoundMetrics;
    /**
     *
     * @type {string}
     * @memberof ServiceExecution
     */
    parent_service_id?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceExecution
     */
    date_of_started?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceExecution
     */
    date_of_finished?: string;
    /**
     *
     * @type {CellInBoundMetricsExecutionTime}
     * @memberof ServiceExecution
     */
    execution_time?: CellInBoundMetricsExecutionTime;
}

export const ServiceExecutionStatusEnum = {
    RUNNING: 'RUNNING',
    WAIT: 'WAIT',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
} as const;

export type ServiceExecutionStatusEnum = (typeof ServiceExecutionStatusEnum)[keyof typeof ServiceExecutionStatusEnum];
